var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","color":"primary","text":""},on:{"click":function($event){return _vm.$emit('clearFilter')}}},[_vm._v("Clear")])
}
var staticRenderFns = []

export { render, staticRenderFns }